import React from 'react'
import '../assets/banniere.css'

function Banniere() {
  return (
    <div className='container-fluid' id='banniere'>
      <div className='marquee'>
          <span>LE PLUS GRAND CATALOGUE DE HHC EN FRANCE</span>
          <span>LIVRAISON EN 48/72H</span>
          <span>QUALITÉ GARANTIE</span>
        </div>
    </div>
  )
}

export default Banniere